import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { Row, Col } from 'antd';
import _ from 'lodash';

import { Input } from 'app/components/FormComponents';
import { Checkbox } from 'app/components/FormComponents';
import Button from 'app/components/Button';

import { IFormFields } from '../type';
import { loginHelpSchema, loginSchema as schema } from '../schema';
import { messages } from '../messages';
import { useLoginSlice } from '../slice';

import mail from 'assets/icons/login/mail.svg';
import profile from 'assets/icons/login/profile.svg';
import lock from 'assets/icons/login/lock.svg';

type Props = {
  error?: { error: string; errorDescription: string } | null;
};

export default function Form(props: Props) {
  const { handleSubmit, control, formState } = useForm<IFormFields>({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const { errors } = formState;
  const dispatch = useDispatch();
  const { actions } = useLoginSlice();
  const history = useHistory();

  const submitForm = (data: IFormFields) => {
    dispatch(actions.login(data));
  };
  const redirectToForgotPassword = () => {
    history.push('/forgot-password');
  };

  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit(submitForm)}>
      <div className="form-inner-content">
        <Row>
          <Col span={24}>
            <Input
              control={control}
              inputName="corporateId"
              placeholder={t(...messages.corporateIdPlaceholder())}
              prefix={<img src={profile} alt={'mail icon'} />}
              error={_.get(errors, 'corporateId')}
              helpInfo={loginHelpSchema.corporateId}
            />
          </Col>
          <Col span={24}>
            <Input
              control={control}
              inputName="userId"
              placeholder={t(...messages.userIdPlaceholder())}
              prefix={<img src={mail} alt={'mail icon'} />}
              error={_.get(errors, 'userId')}
              helpInfo={loginHelpSchema.userId}
            />
          </Col>
          <Col span={24}>
            <Input
              control={control}
              inputName="password"
              password
              placeholder={t(...messages.passwordPlaceholder())}
              prefix={<img src={lock} alt={'mail icon'} />}
              error={_.get(errors, 'password')}
              helpInfo={loginHelpSchema.password}
            />
            {props.error && (
              <p
                className="login-error"
                dangerouslySetInnerHTML={{
                  __html: props.error?.error
                    ? t(props.error.error).replace(
                        '{{}}',
                        props.error.errorDescription,
                      )
                    : '',
                }}
              />
            )}
          </Col>

          <Col span={24}>
            <Button
              label={t(...messages.loginButtonLabel())}
              type="submit"
              variation="login"
            />
          </Col>
          <Col span={24}>
            <div className={'login-form-control'}>
              <Checkbox
                control={control}
                inputName={'remember'}
                error={_.get(errors, 'remember')}
                label={t(...messages.rememberMeLabel())}
              />
              <span onClick={redirectToForgotPassword}>
                {t(...messages.forgetPasswordLabel())}
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </form>
  );
}
